// GAM targeting-signal catalogue (admin toggles on/off; Flutter reads enabled list)
export const GET_GAM_SIGNALS = "GET_GAM_SIGNALS";
export const TOGGLE_GAM_SIGNAL = "TOGGLE_GAM_SIGNAL";
// Nielsen mDAR config (admin-managed; delivered to app with the toggles)
export const GET_NIELSEN_CONFIG = "GET_NIELSEN_CONFIG";
